<template>
  <div>
    <div elevation="0" color="transparent" flat>
      <div class="row mb-8">
        <div class="col-6 d-flex justify-content-start">
          <v-card-title>
            {{ $t('orders.docTitle') }}
          </v-card-title>
        </div>
        <div class="col-6 d-flex justify-content-end  gap-2">
          <genericBtnComponent :ClickFun="navigateToMasterOrders" svg="2" :Title="$t('masterOrders.NavigateToMO')" />
        </div>
      </div>
    </div>

    <v-card elevation="0">
      <orders-list />
    </v-card>
  </div>
</template>

<script>
import OrdersList from "./OrdersList/OrdersList.vue";
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue"

export default {
  components: {
    OrdersList,
    genericBtnComponent
  },
  mounted() {
    document.title = window.VUE_APP_NAME + ' - ' + this.$t('orders.docTitle');
  },
  methods: {
    navigateToMasterOrders() {
      this.$router.push({ name: 'MasterOrders' });
    },
  },
};
</script>

<style scoped>
.v-card-title {
  color: #001e50;
  font-size: 18px;
  line-height: 25.5px;
  font-weight: 700;
  font-family: inter;
}
</style>